import { getConfig } from '@config/index'

import { type NavLinkItem } from '@components/ui-core/types'

const config = getConfig()

/* TODO: Investigate if we can move this to Contentful :) */
export const headerContent: NavLinkItem[] = [
  {
    label: 'Product',
    links: [
      {
        label: 'Superhuman Go',
        href: '/products/go-ai-assistant',
      },
      {
        label: 'Grammarly',
        href: '/products/grammarly',
      },
      {
        label: 'Coda',
        href: '/products/coda',
      },
      {
        label: 'Superhuman Mail',
        href: config.paths.mail.landing,
      },
      {
        label: 'Agent Store',
        href: config.paths.agentStore,
      },
    ],
  },
  {
    label: 'Enterprise',
    href: '/solutions/enterprise',
  },
  {
    label: 'Pricing',
    href: '/plans',
  },
  {
    label: 'Contact us',
    href: '/contact',
  },
]
